export default __webpack_public_path__ + "static/travel-booking-system-a0b9a3cb85418e6d6d85705f8e3245d0.png";